import React from "react";
import { Link, useLocation } from "react-router-dom";
import Card from "../CommonComponents/Card";
import HeadLines from "../CommonComponents/HeadLines";
import style from "./style.module.css";
import { eventTracker } from "../GATracker3.0/eventTracker";
import {
  BOOK_WAREHOUSE_BANNER_CLICKED,
  POST_TRADE_REQUIREMENT_CLICKED,
  SERVICES_CARD_CLICKED,
  exploreServicesEventObject,
} from "../GATracker3.0/constants";
import { isMobile } from "../helperFunc";
const ScrollCard = ({ data, index, showScroll, isExploreWidget = false }) => {
  const location = useLocation();
  return (
    <div
      className={`${
        isMobile
          ? `${style["width-294"]} margin-left16`
          : `${index > 0 && "margin-left16"} width-100 ${
              showScroll ? style["min-width400"] : ""
            }`
      }  display-inline-block`}
    >
      <Card
        className={`boxRadius8 boxShadow8 positionRelative ${
          !isMobile && "desk_card_border"
        }`}
      >
        <div className={`${style["imageCircle"]} positionAbsolute d-flex `}>
          <img
            // className="m-auto"
            src={data.image}
            className={`m-auto ${isMobile ? "" : style["imageHeight"]}`}
            alt=""
          />
        </div>
        <div
          className={`${style["backGroundDkGreen"]} borderRadiusTop  padding-left16 padding-right16px ${style["paddingTopBottom"]}`}
        >
          <HeadLines
            className={`${
              isMobile ? "" : "font-size20 line-height23"
            } textColorWhite font-weight600`}
            text={data.title}
          />
        </div>
        <div>
          <div className={`padding16  ${style["exploreborder"]}`}>
            <Link
              to={data.firstLink}
              onClick={() => {
                if (isExploreWidget) {
                  eventTracker("event", SERVICES_CARD_CLICKED, {
                    addinfo:
                      exploreServicesEventObject[data.title].firstHeading,
                  });
                  if (data.firstLink === "/post-your-requirements") {
                    eventTracker("event", POST_TRADE_REQUIREMENT_CLICKED, {
                      pagename:
                        location.pathname === "/"
                          ? "homepage"
                          : location.pathname,
                      addinfo: "Banner",
                    });
                  }
                  if (data.firstLink === "/warehouse/find-a-warehouse") {
                    eventTracker("event", BOOK_WAREHOUSE_BANNER_CLICKED, {
                      pagename:
                        location.pathname === "/"
                          ? "homepage"
                          : location.pathname,
                    });
                  }
                }
              }}
              className={`${style["unsetDefaultCSS"]} cursorPointer`}
            >
              {" "}
              <HeadLines
                className={` font-weight400 ${
                  isMobile
                    ? "font-size14 line-height16"
                    : "font-size18 line-height21"
                } letterSpacing05`}
                text={data.firstHeading}
              />
            </Link>
          </div>
          <div
            className={`padding16  ${style["exploreborder"]} borderRadiusBottom`}
          >
            <Link
              to={data.secondLink}
              onClick={() => {
                if (isExploreWidget) {
                  eventTracker("event", SERVICES_CARD_CLICKED, {
                    addinfo:
                      exploreServicesEventObject[data.title].secondHeading,
                  });
                }
              }}
              className={`${style["unsetDefaultCSS"]} cursorPointer`}
            >
              {" "}
              <HeadLines
                className={` font-weight400 ${
                  isMobile
                    ? "font-size14 line-height16"
                    : "font-size18 line-height21"
                } letterSpacing05`}
                text={data.secondHeading}
              />
            </Link>
          </div>
        </div>
      </Card>
    </div>
  );
};
export default ScrollCard;
